import type { LabObservationView } from '../../types/labResults';

// Product heuristic adapted from patient-dashboard.skill, not a validated
// clinical score. Freeze these weights under v1 so changes are explicit.
export const LAB_FLAG_SCORE = { version: 'v1', baseline: 100, criticalPenalty: 12, abnormalPenalty: 4 } as const;

export function calculateLabFlagScore(observations: readonly LabObservationView[]) {
  let critical = 0;
  let abnormal = 0;
  let normal = 0;
  for (const observation of observations) {
    switch (observation.flag) {
      case 'critical_high':
      case 'critical_low': critical++; break;
      case 'high':
      case 'low':
      case 'abnormal': abnormal++; break;
      case 'normal': normal++; break;
      // Never treat an absent or unrecognized flag as normal.
    }
  }
  const assessed = critical + abnormal + normal;
  return {
    value: assessed ? Math.max(0, LAB_FLAG_SCORE.baseline - critical * LAB_FLAG_SCORE.criticalPenalty - abnormal * LAB_FLAG_SCORE.abnormalPenalty) : null,
    critical, abnormal, assessed, total: observations.length, unassessed: observations.length - assessed,
  };
}
